import { createSvgIcon } from '@mui/material';

const PortfolioIcon = createSvgIcon(
  <path
    d='M6.7 21.3C6.51667 21.1167 6.425 20.8833 6.425 20.6C6.425 20.3167 6.51667 20.0833 6.7 19.9L11.475 15.1C11.8583 14.7167 12.3333 14.525 12.9 14.525C13.4667 14.525 13.9417 14.7167 14.325 15.1L16.4 17.175L20.875 12.7C21.075 12.5 21.3083 12.4 21.575 12.4C21.8417 12.4 22.075 12.5 22.275 12.7C22.475 12.9 22.575 13.1375 22.575 13.4125C22.575 13.6875 22.475 13.925 22.275 14.125L17.825 18.6C17.4417 18.9833 16.9708 19.175 16.4125 19.175C15.8542 19.175 15.3833 18.9833 15 18.6L12.9 16.5L8.1 21.3C7.91667 21.4833 7.6875 21.5792 7.4125 21.5875C7.1375 21.5958 6.9 21.5 6.7 21.3ZM4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V5C2 4.45 2.19583 3.97917 2.5875 3.5875C2.97917 3.19583 3.45 3 4 3H18C18.55 3 19.0208 3.19583 19.4125 3.5875C19.8042 3.97917 20 4.45 20 5V9C20 9.28333 19.9042 9.52083 19.7125 9.7125C19.5208 9.90417 19.2833 10 19 10H4V21ZM4 8H18V5H4V8Z'
    fill='inherit'
    fillOpacity='inherit'
  />,
  'table-chart-view',
);

export default PortfolioIcon;
